export default "__VITE_ASSET__B_3HuTK8__"